
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

let filterSeed = 0

@Options({
    name: 'good-road-btn-svg'
})
export default class GoodRoadBtnSvg extends Vue {
    @Prop({ default: 0 }) count!: number

    filterId = `good-road-filter-${++filterSeed}`
}
